module.exports = __webpack_public_path__ + "img/sample-report-11@3x.783d5cf0.png";